import Vue from 'vue';
import Component from 'vue-class-component';
import DxTextBox from 'devextreme-vue/text-box';
import postModule from '../../../store/modules/post.module';

@Component({
  components: {
    DxTextBox,    
  },
})
export default class SearchBarComponent extends Vue {
  public search: string = '';

  public created() {
    document.getElementById('searchButton')?.addEventListener("change", () => this.onChange());
  }

  public onChange() {
    postModule.filterPosts(this.search);
  }
}